import { useState } from "react";
import { ChatCircleText, ArrowsClockwise } from "@phosphor-icons/react";
import { glassQuotes, pickNextIndex } from "@/data/funzone";

export const GlassQuoteCard = () => {
  const [idx, setIdx] = useState(0);

  return (
    <div
      className="rounded-3xl bg-teal-50 border border-teal-100 shadow-sm p-6 md:p-8 flex flex-col items-center text-center transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-xl"
      data-testid="glass-quote-card"
    >
      <div className="w-12 h-12 rounded-2xl bg-teal-100 text-teal-700 flex items-center justify-center">
        <ChatCircleText size={26} weight="duotone" />
      </div>
      <h3 className="mt-4 text-xl font-bold text-slate-900">Scheibenspruch</h3>
      <p className="mt-1 text-sm text-teal-700 font-medium">Ein guter Spruch für klare Sicht.</p>

      <svg viewBox="0 0 120 60" className="mt-5 w-24" aria-hidden="true">
        <path d="M18 14 Q60 4 102 14 L110 48 Q60 56 10 48 Z" fill="#ccfbf1" stroke="#0f766e" strokeWidth="3" strokeLinejoin="round" />
        <path d="M30 20 L44 44" stroke="#5eead4" strokeWidth="4" strokeLinecap="round" opacity="0.8" />
        <circle cx="72" cy="30" r="3" fill="#0f766e" />
        <circle cx="86" cy="30" r="3" fill="#0f766e" />
        <path d="M74 38 Q79 42 84 38" stroke="#0f766e" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      </svg>

      <p key={idx} className="fz-fade-in mt-5 min-h-[4.5rem] flex items-center text-lg md:text-xl font-bold text-slate-800 leading-snug" data-testid="glass-quote-text">
        „{glassQuotes[idx]}"
      </p>

      <button
        onClick={() => setIdx(pickNextIndex(glassQuotes, idx))}
        className="mt-auto pt-5 w-full"
        data-testid="glass-quote-button"
      >
        <span className="inline-flex items-center justify-center gap-2 w-full h-12 rounded-xl bg-teal-600 hover:bg-teal-700 active:scale-[0.98] text-white font-semibold transition-[background-color,transform] duration-200 focus-visible:ring-2 focus-visible:ring-teal-400 focus-visible:ring-offset-2">
          <ArrowsClockwise size={18} weight="bold" />
          Anderen Spruch anzeigen
        </span>
      </button>
    </div>
  );
};
